import React from "react";

export const DiveIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.52344 12.4762C1.52344 11.4286 2.38058 10.5714 3.4282 10.5714C4.47582 10.5714 5.33296 11.4286 5.33296 12.4762C5.33296 13.5238 4.47582 14.381 3.4282 14.381C2.38058 14.381 1.52344 13.5238 1.52344 12.4762ZM9.03772 9.72381L13.352 8.57143L12.6092 5.80952L8.29487 6.9619C7.53296 7.1619 7.07582 7.95238 7.28534 8.71429C7.49487 9.47619 8.27582 9.93333 9.03772 9.72381ZM20.0949 5.71429L22.4758 2.95238L21.5234 2L18.6663 4.85714L16.7615 8.66667L7.73296 11.4C6.95201 11.5905 6.40915 12.2476 6.30439 13L5.56153 17.2381L2.85677 20.8571L4.38058 22L7.23772 18.1905L8.32344 15.2L13.9044 13.4286L18.6663 10.0952L20.0949 5.71429Z"
      fill="currentColor"
    />
  </svg>
);
